import API_MAP from "../../util/API_MAP";
import API_MANAGER from "../../util/API_MANAGER";
import router from '../../router';

const state = {

};

const getters = {

};

const actions = {
	// 提交基本信息
	submitInformation({commit, rootState}, option) {
		const {values, cb} = option;
		const language = rootState.main.language;
		let api = API_MAP.USER_BASIC;
		let method = 'json';
		let payload = values;
		payload.user_id = rootState.main.currentUser['user_id'];
		let successCb = () => {
			commit('main/updateCurrentUser', payload, { root: true });
			cb();
			location.reload();
			// if (rootState.main.isSecondEnter) {
			// 	commit('main/backToSummary', null, { root: true });
			// } else {
			// 	commit('goToNext', language);
			// }
		};
		let errorCb = () => {
			cb();
			// commit('goToNext', language);
		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	}
};

const mutations = {
	// 前往下一步
	goToNext(state, language) {
		if (language === 'zh') {
			router.push('/activity');
		} else {
			router.push('/en/activity');
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
